import { useEffect } from 'react';

export function useClickOutside(ref: React.RefObject<HTMLElement>, closeCallback: (item: boolean) => void) {
    useEffect(() => {
        function handleClick(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setTimeout(() => closeCallback(false), 0);
            }
        }

        document.addEventListener('mouseup', handleClick);
        return () => {
            document.removeEventListener('mouseup', handleClick);
        };
    }, []);
}
